export default __webpack_public_path__ + "static/media/sos.56ece403.png";